'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCogDatabase, iconCogDatabaseTag } from '@ni/nimble-components/dist/esm/icons/cog-database';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCogDatabase };
export { iconCogDatabaseTag };
export const NimbleIconCogDatabase = wrap(IconCogDatabase);